// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarSelect_wrapper","placeholder":"AvatarSelect_placeholder"};